<template>
  <div class="double12 text-NotoSansLight">
    <div class="main w-full">
      <div class="fixed-btn fixed left-0 hidden lg:block z-50">
        <img src="~@/assets/images/double12_2021/b_01.png" class="object-contain">
        <a @click="toMag()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_02.png" class="object-contain"></a>
        <a @click="toPackage()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_03.png" class="object-contain"></a>
        <a @click="toPrice()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_04.png" class="object-contain"></a>
        <a @click="toGraph()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_06.png" class="object-contain"></a>
        <a @click="toLife()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_07.png" class="object-contain"></a>
        <a @click="toTest()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_08.png" class="object-contain"></a>
        <a @click="toWorkPlace()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_09.png" class="object-contain"></a>
        <a @click="toIntro()" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_05.png" class="object-contain"></a>
        <router-link :to="{ name: 'login' }" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_10.png" class="object-contain"></router-link>
        <router-link :to="{ name: 'checkout' }" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_11.png" class="object-contain"></router-link>
        <router-link :to="{ name: 'index' }" class="cursor-pointer block"><img src="~@/assets/images/double12_2021/b_12.png" class="object-contain"></router-link>
      </div>

      <section class="banner">
        <div class="container" >
          <div data-aos="fade-up" data-aos-once="true">
            <div><img src="~@/assets/images/double12_2021/top_pc.png" class="object-contain h-auto w-full max-w-full mx-auto hidden md:block"></div>
            <div><img src="~@/assets/images/double12_2021/top_mo.png" class="object-contain h-auto w-full max-w-full mx-auto md:hidden"></div>
          </div>
        </div>
      </section>

      <!-- <router-link :to="{ name: 'magazine' }" class="pt-3 pb-5 block cursor-pointer mx-auto">
        <img src="~@/assets/images/double12_2021/more.png" class="object-contain mx-auto">
      </router-link> -->

      <!-- 1 -->
      <section class="container px-2" id="Mag">
        <div class="flex justify-center lg:justify-start max-w-5xl lg:ml-20 px-2 mb-4">
          <div class="mr-4"><img src="~@/assets/images/double12_2021/P1 (3).png" class="object-contain"></div>
          <div><img src="~@/assets/images/double12_2021/P2 (1).png" class="object-contain"></div>
        </div>
        <div class="flex justify-center flex-wrap" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="w-1/2 md:w-1/3 md:p-3 cursor-pointer item" v-for="(item, index) in magList" :key="index">
            <img :src="item.img_url" class="object-contain h-auto w-full max-w-full mx-auto">
          </router-link>
        </div>

          <router-link :to="{ name: 'magazine' }" class="block cursor-pointer mx-auto">
            <img src="~@/assets/images/double12_2021/m.png" class="object-contain mx-auto">
          </router-link>
          <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: 108 } }" class="py-3 block cursor-pointer mx-auto more">
            <img src="~@/assets/images/double12_2021/more_1.png" class="object-contain mx-auto">
          </router-link>
      </section>

      <!-- 2 -->
      <section class="container px-2" id="package">
        <div class="flex justify-center lg:justify-start max-w-5xl lg:ml-20 px-2 mb-4">
          <div class="mr-4"><img src="~@/assets/images/double12_2021/P1 (2).png" class="object-contain"></div>
          <div><img src="~@/assets/images/double12_2021/P2 (2).png" class="object-contain"></div>
        </div>
        <div class="flex justify-center flex-wrap" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true">
          <router-link :to="{ name: 'detail', params: { category: item.params, id: item.id } }" class="w-1/2 md:w-1/3 md:p-3 cursor-pointer item" v-for="(item, index) in packageList" :key="index">
            <img :src="item.img_url" class="object-contain h-auto w-full max-w-full mx-auto">
          </router-link>
        </div>
        <router-link :to="{ name: 'sale', params: { category: 'magazine' }, query: { tag: 114 } }" class="pt-3 pb-5 block cursor-pointer mx-auto more">
          <img src="~@/assets/images/double12_2021/more_1.png" class="object-contain mx-auto">
        </router-link>
      </section>

      <!-- 3 -->
      <section class="container pb-6 px-2" id="Price">
        <div class="flex justify-center lg:justify-start max-w-5xl lg:ml-20 px-2 mb-4">
          <div class="mr-4"><img src="~@/assets/images/double12_2021/P1 (1).png" class="object-contain"></div>
          <div><img src="~@/assets/images/double12_2021/P2 (3).png" class="object-contain"></div>
        </div>
        <router-link :to="{ name: 'sale', params: { category: 'recent' }, query: { tag: 115 } }" class="max-w-5xl mx-auto block" data-aos="fade-up" data-aos-once="true">
          <img src="~@/assets/images/double12_2021/P3.png" class="object-contain mx-auto">
        </router-link>
      </section>

      <!-- 書籍列表 -->
      <section class="bookList container px-2" v-for="(item, index) in bookList" :key="index" :id="item.id">
        <div class="flex justify-center">
          <div class="mr-4"><img :src="item.titleUrl" class="object-contain mx-auto"></div>
        </div>
        <div class="flex justify-center flex-wrap" data-aos="fade-in" data-aos-easing="ease" data-aos-once="true">
          <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="w-1/2 md:w-1/3 md:p-3 cursor-pointer item" v-for="(child, idx) in item.items" :key="idx">
            <img :src="child.img_url" class="object-contain h-auto w-full max-w-full mx-auto">
          </router-link>
        </div>
      </section>

      <router-link :to="{ name: 'productsList', params:{ category: 'book' },  query: { type: 'BOOK' } }" class="pt-3 pb-5 block cursor-pointer mx-auto">
        <img src="~@/assets/images/double12_2021/more.png" class="object-contain mx-auto">
      </router-link>

      <!-- 注意事項 -->
      <section class="container pb-6 px-2" id="Intro">
        <img src="~@/assets/images/double12_2021/P4.png" class="object-contain mx-auto w-full h-auto block my-3">

        <div class="max-w-4xl mx-auto px-6">
          <ul class="list-decimal list-outside font-semibold">
            <li>抽獎辦法：於活動期間2021/12/1至2021/12/31止，單筆消費金額超過1212元(*結帳金額需為1,213元以上)，即符合抽獎資格。 </li>
            <li>抽獎公佈日期：2022/1/20公佈於LiveABC官方網站（https://store.liveabc.com/）。</li>
            <li>中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。  </li>
            <li>中華民國稅法規定，凡贈與獎項金額超過新台幣20,000元，將依法課徵10%所得稅。</li>
            <li>由於中獎獎品之價值會受市場價格波動之影響，因以中獎通知單內所標明之贈品價值為準。</li>
            <li>本活動之抽獎贈品不得轉換、轉讓或折換現金。</li>
            <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
          </ul>
        </div>
      </section>
      <footer class="pt-28 pb-12 flex justify-center">
        <router-link :to="{ name: 'index' }" class="block mx-auto">
          <img class="object-contain" src="~@/assets/images/double12_2021/logo.png" alt="livaABC">
        </router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'double12_2021',
  metaInfo () {
    return {
      title: '1212 LiveABC年終購物節',
      titleTemplate: null
    }
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      bookList: [
        { titleUrl: require('@/assets/images/double12_2021/t1.png'),
          id: 'graph',
          items: [
            { name: 'ABC', id: 7496, img_url: require('@/assets/images/double12_2021/1-1.png') },
            { name: 'LIVE', id: 7445, img_url: require('@/assets/images/double12_2021/1-2.png') },
            { name: 'ALL', id: 7405, img_url: require('@/assets/images/double12_2021/1-3.png') }
          ]
        },
        { titleUrl: require('@/assets/images/double12_2021/t2.png'),
          id: 'life',
          items: [
            { name: 'ABC', id: 5965, img_url: require('@/assets/images/double12_2021/2-1.png') },
            { name: 'LIVE', id: 7149, img_url: require('@/assets/images/double12_2021/2-2.png') },
            { name: 'ALL', id: 6385, img_url: require('@/assets/images/double12_2021/2-3.png') },
            { name: 'CNN', id: 7219, img_url: require('@/assets/images/double12_2021/2-4.png') },
            { name: 'JP', id: 7003, img_url: require('@/assets/images/double12_2021/2-5.png') },
            { name: 'HW', id: 6934, img_url: require('@/assets/images/double12_2021/2-6.png') }
          ]
        },
        { titleUrl: require('@/assets/images/double12_2021/t3.png'),
          id: 'text',
          items: [
            { name: 'ABC', id: 7456, img_url: require('@/assets/images/double12_2021/3-1.png') },
            { name: 'LIVE', id: 7399, img_url: require('@/assets/images/double12_2021/3-2.png') },
            { name: 'ALL', id: 4229, img_url: require('@/assets/images/double12_2021/3-3.png') },
            { name: 'CNN', id: 6869, img_url: require('@/assets/images/double12_2021/3-4.png') },
            { name: 'JP', id: 905, img_url: require('@/assets/images/double12_2021/3-5.png') },
            { name: 'HW', id: 7104, img_url: require('@/assets/images/double12_2021/3-6.png') }
          ]
        },
        { titleUrl: require('@/assets/images/double12_2021/t4.png'),
          id: 'workPlace',
          items: [
            { name: 'ABC', id: 7236, img_url: require('@/assets/images/double12_2021/4-1.png') },
            { name: 'LIVE', id: 7093, img_url: require('@/assets/images/double12_2021/4-2.png') },
            { name: 'ALL', id: 6936, img_url: require('@/assets/images/double12_2021/4-3.png') }
          ]
        }
      ],
      magList: [
        { name: 'ABC', id: 7246, img_url: require('@/assets/images/double12_2021/mag (1).png') },
        { name: 'LIVE', id: 7248, img_url: require('@/assets/images/double12_2021/mag (2).png') },
        { name: 'ALL', id: 7250, img_url: require('@/assets/images/double12_2021/mag (3).png') },
        { name: 'CNN', id: 7252, img_url: require('@/assets/images/double12_2021/mag (4).png') },
        { name: 'JP', id: 7254, img_url: require('@/assets/images/double12_2021/mag (5).png') },
        { name: 'HW', id: 7340, img_url: require('@/assets/images/double12_2021/mag (6).png') }
      ],
      packageList: [
        { name: 'ABC', params: 'package', id: 7208, img_url: require('@/assets/images/double12_2021/s (1).png') },
        { name: 'LIVE', params: 'package', id: 7384, img_url: require('@/assets/images/double12_2021/s (2).png') },
        { name: 'ALL', params: 'livepen', id: 7075, img_url: require('@/assets/images/double12_2021/s (3).png') },
        { name: 'CNN', params: 'package', id: 7388, img_url: require('@/assets/images/double12_2021/s (4).png') },
        { name: 'JP', params: 'package', id: 6555, img_url: require('@/assets/images/double12_2021/s (5).png') },
        { name: 'HW', params: 'livepen', id: 7414, img_url: require('@/assets/images/double12_2021/s (6).png') }
      ]
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    toMag () {
      jump('#Mag', {
        duration: 500,
        offset: 0
      })
    },
    toPackage () {
      jump('#package', {
        duration: 500,
        offset: 0
      })
    },
    toPrice () {
      jump('#Price', {
        duration: 500,
        offset: 0
      })
    },
    toIntro () {
      jump('#Intro', {
        duration: 500,
        offset: 0
      })
    },
    toGraph () {
      jump('#graph', {
        duration: 500,
        offset: 0
      })
    },
    toLife () {
      jump('#life', {
        duration: 500,
        offset: 0
      })
    },
    toTest () {
      jump('#text', {
        duration: 500,
        offset: 0
      })
    },
    toWorkPlace () {
      jump('#workPlace', {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.double12 {
  .pt-28 {
    padding-top: 7rem;
  }
  .main {
    background: #F3F3E9;
    .fixed-btn {
      top: 50%;
      transform: translateY(-50%);
      width: 175px;
    }
    .more {
      width: 250px;
    }
    ul {
      color: #443e3d;
      line-height: 38px;
    }
    .item {
      transition: all 0.4s ease;
      &:hover {
        transform: translateY(-6px);
      }
    }
  }
}
</style>
